import {
  CurrencyStringCents,
  DisabledNotAvailableAbbr,
} from '@b-stock/fe-core/bstock-react'
import { ListingEnums } from '@b-stock/fe-core/locale'
import type {
  ItemCategoriesDtoCategoriesEnum,
  ItemCategoriesDtoSubcategoriesEnum,
  ItemDtoItemConditionEnum,
} from '@b-stock/listing-api-client'

export const CategoryCell = ({
  value,
}: {
  value?: ItemCategoriesDtoCategoriesEnum
}) =>
  value ? (
    <ListingEnums.Category.Component value={value} />
  ) : (
    <DisabledNotAvailableAbbr />
  )

// Note: ItemCondition overrides are accounted for on the BE for the pivot tables
export const ConditionCell = ({
  value,
}: {
  value?: ItemDtoItemConditionEnum
}) =>
  value ? (
    <ListingEnums.ItemCondition.Component value={value} />
  ) : (
    <DisabledNotAvailableAbbr />
  )

export const ExtMsrpCell = ({
  currency,
  value,
}: {
  currency?: string
  value?: number | null
}) => {
  const msrp = value ?? 0
  return msrp > 0 ? (
    <CurrencyStringCents value={msrp} currency={currency ?? 'USD'} />
  ) : (
    <DisabledNotAvailableAbbr />
  )
}

export const SubcategoryCell = ({
  value,
}: {
  value?: ItemCategoriesDtoSubcategoriesEnum
}) =>
  value ? (
    <ListingEnums.Subcategory.Component value={value} />
  ) : (
    <DisabledNotAvailableAbbr />
  )

export const TextCell = ({ value }: { value?: string }) =>
  !value || value === 'None' ? <DisabledNotAvailableAbbr /> : value
